import { Link } from "@tanstack/react-router";
import { ShieldX } from "lucide-react";
import { Button } from "@/components/ui/button";

export function AdminUnauthorized() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="max-w-md w-full bg-white shadow-lg rounded-lg p-8 text-center">
        <div className="mb-6">
          <ShieldX className="mx-auto h-16 w-16 text-red-500" />
        </div>

        <h1 className="text-2xl font-bold text-gray-900 mb-4">Access Denied</h1>

        <p className="text-gray-600 mb-8">
          Your account is not authorized to view this page. Only administrators
          can access this area.
        </p>

        <div className="space-y-4">
          <Button asChild className="w-full">
            <Link to="/auth-org/signin">Login as Different User</Link>
          </Button>

          <Button variant="outline" asChild className="w-full">
            <Link to="/">Go to Home Page</Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
